import { INavigation } from '@core/interfaces/interface';
import { PatientNavigationEnum } from './navigation.enum';

export const navigationPatient: INavigation[] = [
  {
    title: 'back',
    patch: `/`,
    icon: 'bi-house-fill',
    sublist: [],
    expanded: false,
    endpoint: true,
  },
  {
    title: 'profile',
    patch: PatientNavigationEnum.profile,
    icon: 'bi-person-circle',
    sublist: [],
    expanded: false,
    endpoint: true,
  },
  {
    title: 'basket',
    patch: PatientNavigationEnum.basket,
    icon: 'bi-basket2-fill',
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'calendar',
    patch: PatientNavigationEnum.calendar,
    icon: 'bi-calendar-check-fill',
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'telediagnosis',
    patch: PatientNavigationEnum.telediagnosis,
    icon: 'bi-heart',
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'order_history',
    patch: PatientNavigationEnum.order,
    icon: 'bi-journals',
    sublist: [
      {
        title: 'rehabilitation_programs',
        patch: PatientNavigationEnum.order + '/' + PatientNavigationEnum.order_list_rehabilitation,
        expanded: false,
        sublist: [],
        endpoint: false,
      },
      {
        title: 'education_programs',
        patch: PatientNavigationEnum.order + '/' + PatientNavigationEnum.order_list_education,
        expanded: false,
        sublist: [],
        endpoint: false,
      },
      {
        title: 'services',
        patch: PatientNavigationEnum.order + '/' + PatientNavigationEnum.order_list_service,
        expanded: false,
        sublist: [],
        endpoint: false,
      },
    ],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'physician_assistant.title_patient',
    patch: PatientNavigationEnum.physical_assistant,
    icon: 'bi-robot',
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'access.title',
    patch: PatientNavigationEnum.access,
    icon: 'bi-shield-lock',
    sublist: [],
    expanded: false,
    endpoint: false,
  },
];
